import request, { IWorkspaceResponse } from './http/Xrequest '
import { encryptPathSegment } from './rsa/api-crypto'

// 更新机场设备使用状态
export async function updateAirportDeviceStatus (deviceId: string, status: string): Promise<IWorkspaceResponse> {
  const url = `/device/update-use-status/${deviceId}/${status}`
  const result = await request.get(url)
  return result.data
}

// 分页查询空域申请
export async function getAirspaceApplications (body: {}): Promise<IWorkspaceResponse> {
  const url = '/business/airspace/page'
  const result = await request.post(url, body)
  return result.data
}

// 获取空域申请详情
export async function getAirspaceApplicationDetail (id: string): Promise<IWorkspaceResponse> {
  const url = `/business/airspace/${id}`
  const result = await request.get(url)
  return result.data
}

// 获取登录人项目的文件夹（部门）
export async function getUserProjectFolders (): Promise<IWorkspaceResponse> {
  const url = '/business/modelfolder/tree-dept-by-login-user'
  const result = await request.get(url)
  return result.data
}

// 根据文件夹id获取对应的模型
export async function getModelsByFolderId (folderId: string): Promise<IWorkspaceResponse> {
  const url = `/business/modelfolder/get-detail-by-folder-id/${folderId}`
  const result = await request.get(url)
  return result.data
}

// 根据文件夹id获取对应的模型-分类
export async function getModelsByFolderIdClassification (folderId: string): Promise<IWorkspaceResponse> {
  const url = `/business/modelfolder/get-detail-by-folder-id-for-map/${folderId}`
  const result = await request.get(url)
  return result.data
}

// getConfigKey
export async function getConfigKey (configKey: string): Promise<IWorkspaceResponse> {
  const url = `/system/config/configKey/${encryptPathSegment(configKey)}`
  const result = await request.get(url)
  return result.data
}

// 选择媒体-生成正射影像图
export async function getGenerateorthophoto (body: {}): Promise<IWorkspaceResponse> {
  const url = '/api/odm/generate3d-external'
  const result = await request.post(url, body)
  return result.data
}

// 添加告警
export async function getAddAlarm (body: {}): Promise<IWorkspaceResponse> {
  const url = '/alarm/add-alarm'
  const result = await request.post(url, body)
  return result.data
}

// 获取视频分片Url
export async function getVideoSegmentUrl (param: {}): Promise<IWorkspaceResponse> {
  const url = '/minio-file/get-video-slices-url'
  const result = await request.post(url, param)
  return result.data
}

// 获取项目模型、媒体的容量
export async function getModelsMediaCapacity (workspaceId): Promise<IWorkspaceResponse> {
  const url = `/business/modelfolder/get-usage-by-workspace-id/${workspaceId}`
  const result = await request.post(url)
  return result.data
}
